var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.xAxisData.length)?_c('e-charts',{staticClass:"chart",attrs:{"options":_vm.options}}):_c('not-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }